export default __webpack_public_path__ + "static/media/GAB.38516199.svg";